import React, { useState, useEffect } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import ApplePay from 'services/ApplePay';
import { Button, Image } from 'components/ui';
import { mediaQueries } from 'style/config';

/**
 * Apple Pay Pill Button - Release 4 Style
 * Renders as a pill-shaped button with Apple Pay logo
 */
const Apple = props => {
    // isApplePayEnabledForThisOrder is false if it has a giftcard AND split payment NOT enabled
    const { isApplePayEnabledForThisOrder = true, handlePayWithApplePayClick, orderDetails } = props;
    const [isApplePayEnabled, setIsApplePayEnabled] = useState(false);

    useEffect(() => {
        if (!(isApplePayEnabledForThisOrder && orderDetails)) {
            setIsApplePayEnabled(false);

            return undefined;
        }

        let isCancelled = false;

        ApplePay.getApplePaymentType(orderDetails)
            .then(payType => {
                if (!isCancelled) {
                    setIsApplePayEnabled(payType !== ApplePay.TYPES.HIDDEN);
                }
            })
            .catch(err => {
                Sephora.logger.error('[ApplePay] getApplePaymentType failed', err);

                if (!isCancelled) {
                    setIsApplePayEnabled(false);
                }
            });

        return () => {
            isCancelled = true;
        };
    }, [isApplePayEnabledForThisOrder, orderDetails]);

    if (!isApplePayEnabledForThisOrder || !isApplePayEnabled) {
        return null;
    }

    return (
        <Button
            variant='primary'
            onClick={handlePayWithApplePayClick}
            data-at={Sephora.debug.dataAt('apple_pay_button')}
            aria-label='Pay with Apple Pay'
            css={styles}
            width={['100%', '151px', '100%']}
        >
            <Image
                src='/img/ufe/logo-apple-pay.svg'
                alt=''
                aria-hidden='true'
                height='24px'
            />
        </Button>
    );
};

const styles = {
    backgroundColor: '#000',
    borderRadius: '22px',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 24px',
    gap: '12px',
    flexShrink: 0,
    [mediaQueries.xsMax]: {
        padding: '8px 16px'
    },
    '&:hover': {
        backgroundColor: '#333'
    }
};

export default wrapFunctionalComponent(Apple, 'Apple');
